import apiClient from './client';

export interface SearchActorHit {
  id: number;
  name: string;
  type: string;
  threatLevel: string;
}

export interface SearchCampaignHit {
  id: number;
  name: string;
  status: string;
  severity: string;
}

export interface SearchIndicatorHit {
  id: number;
  type: string;
  value: string;
  severity: string;
}

export interface SearchRuleHit {
  id: number;
  name: string;
  severity: string;
}

export interface SearchReportHit {
  id: number;
  title: string;
  status: string;
  overallThreatLevel: string;
}

export interface SearchTechniqueHit {
  id: string;
  name: string;
  tacticId: string;
}

export interface SearchResults {
  actors: SearchActorHit[];
  campaigns: SearchCampaignHit[];
  indicators: SearchIndicatorHit[];
  rules: SearchRuleHit[];
  reports: SearchReportHit[];
  techniques: SearchTechniqueHit[];
}

export interface SearchResponse {
  query: string;
  results: SearchResults;
  total: number;
}

export async function searchGlobal(
  q: string,
  signal?: AbortSignal,
): Promise<SearchResponse> {
  const { data } = await apiClient.get<SearchResponse>('/search', {
    params: { q },
    signal,
  });
  return data;
}
